// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1w09d"};


//////////////////
// WEBPACK FOOTER
// ./components/container/style.scss
// module id = /A18
// module chunks = 8